import { createContext } from "react";
import { IChannelsContext } from "./models/IChannelsContext.ts";
import { IChannel } from "../interfaces/IChannel.ts";

export const ChannelsContext = createContext<IChannelsContext>({
    channels: [],
    getChannels: () => Promise.resolve(),
    getRecommendedChannels: () => { },
    updateEpgListToActualTime: (channels: IChannel[]) => { channels; },
    allChannels: [],
    filteredChannels: [],
    recommendedChannels: [],
    genres: [],
    setFilteredChannels: () => { },
    setRecommendedChannels: () => { },
    setAllChannels: () => { },
    addChannel: (channels: IChannel) => {channels; },
    updateChannel: (channelToUpdate: IChannel) => { channelToUpdate; },
});